import { SettingsFeatureState } from './settings-feature-state.interface';

export interface AppState {
    // just the same as the feature key
    aumicoSettingsMicroservice: SettingsFeatureState;
}
